import React from "react";
import { FieldError, FieldValues, Path, UseFormRegister } from "react-hook-form";
import clsx from "clsx";

import styles from "./style.module.scss";

interface IProps<T extends FieldValues>
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  id?: string;
  name?: Path<T>;
  register?: UseFormRegister<T>;
  children?: string | React.ReactNode;
  error?: FieldError;
  wrapperClass?: string;
  checkClass?: string;
  checkBoxClass?: string;
  checked?: boolean;
  onChange?: (() => void) | ((event: React.ChangeEvent<HTMLInputElement>) => void);
  disabled?: boolean;
}

export default function Checkbox<T extends FieldValues>({
  id = "smart-checkbox",
  name,
  register,
  children,
  error,
  onChange,
  wrapperClass,
  checkClass,
  checkBoxClass,
  checked,
  disabled = false
}: Readonly<IProps<T>>) {
  return (
    <div className={clsx(styles.smartCheckboxContainer, wrapperClass)}>
      <div className={clsx(styles.smartCheckboxWrapper, checkClass)}>
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          className={clsx(
            styles.smartCheckbox,
            checkBoxClass,
            disabled && "!bg-subtitle !border-subtitle !cursor-not-allowed"
          )}
          {...(register && name && register(name))}
          disabled={disabled}
        />
        <label className={styles.smartCheckboxLabel} htmlFor={id}>
          {children}
        </label>
      </div>
      {error && <span className={styles.smartCheckboxError}>{error.message}</span>}
    </div>
  );
}
